package navigation.home.task.addedittask

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.AddTaskUseCase
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase
import com.essntl.features.task.ui.addedittask.AddEditTaskEvent
import com.essntl.features.task.ui.addedittask.AddEditTaskState
import com.essntl.features.task.ui.addedittask.AddEditTaskValidation
import com.essntl.features.task.ui.addedittask.AddEditTaskViewModel

class AddEditTaskScreenModel(
    itineraryRepository: ItineraryRepository,
    taskRepository: TaskRepository,
    profileRepository: ProfileRepository,
    addTaskUseCase: AddTaskUseCase,
    updateTaskUseCase: UpdateTaskUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditTaskState>(AddEditTaskState()) {
    val validation = AddEditTaskValidation()

    private val addEditTaskViewModel =
        AddEditTaskViewModel(
            itineraryRepository = itineraryRepository,
            taskRepository = taskRepository,
            profileRepository = profileRepository,
            addTaskUseCase = addTaskUseCase,
            updateTaskUseCase = updateTaskUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AddEditTaskEvent) {
        addEditTaskViewModel.onEvent(event)
    }
}
